import { configure, defineRule } from '@uplatform-ai/fe-form-kit'
import { localize } from '@vee-validate/i18n'
import en from '@vee-validate/i18n/dist/locale/en.json'
import ru from '@vee-validate/i18n/dist/locale/ru.json'
import { all } from '@vee-validate/rules'
import { defineVuePlugin } from '#/vue-plugins'

const localValidators = import.meta.glob('./validators/*.ts', { eager: true })

export default defineVuePlugin(() => {
  const locales = {
    en,
    ru,
  }
  configure({
    generateMessage: localize(locales),
  })

  Object.entries(localValidators).forEach(([name, module]) => {
    defineRule(
      name.replace('./validators/', '').replace('.ts', ''),
      (module as { default: (...params: unknown[]) => boolean }).default,
    )
  })
  Object.entries(all).forEach(([name, rule]) => {
    defineRule(name, rule)
  })
})
